// extracted by mini-css-extract-plugin
module.exports = {"root":"Question_root__1tvWo","question":"Question_question__N8jtS","description":"Question_description__29_hX"};